import { useSyncExternalStore } from 'react'
import { pubSub } from '../../app-state/pubSub'
import { getRoomState } from '../../app-state/state.room'

const getRooms = () => getRoomState()
const subRooms = (callback: () => void) => pubSub.ROOM.on('state', callback)

export const useRooms = () => {
    return useSyncExternalStore(subRooms, getRooms, getRooms)
}
